// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// init Swiper for the original slider
var swiper = new Swiper(".mySwiper", {
  slidesPerView: 1.5,
  slidesPerGroup: 1,  // Default group size for advancing slides
  centeredSlides: false,
  spaceBetween: 20,
  grabCursor: true,
  freeMode: false,  // Disabled for better group sliding behavior
  freeModeMomentum: false,
  loop: false,  // Disabled to avoid pagination issues with groups
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    // Removed dynamicBullets to prevent pagination from shifting
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      enabled: true,
      slidesPerView: 1.5,
      slidesPerGroup: 1,  // Advance 1 slide on mobile
      pagination: {
        enabled: false,  // Keep pagination disabled on tablet
      },
    },
    768: {
      enabled: true,
      slidesPerView: 3,
      slidesPerGroup: 3,  // Advance 3 slides on tablet
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    1024: {
      enabled: true,
      slidesPerView: 4,
      slidesPerGroup: 4,  // Advance 4 slides on large tablet
      pagination: {
        enabled: true,  // Keep pagination enabled on large tablet
      },
    },
    1400: {
      enabled: true,  // Changed from false to enable slider on desktop
      slidesPerView: 5,  // Show 5 items on desktop (reduced from 6 for arrow space)
      slidesPerGroup: 5,  // Advance 5 slides on desktop
      pagination: {
        enabled: true,   // Enable pagination on desktop
      },
    }
  }
});


// init Swiper for the secondary slider
var swiperSecondary = new Swiper(".mySwiperSecondary", {
  slidesPerView: 1.5,
  centeredSlides: false,
  spaceBetween: 20,
  grabCursor: true,
  freeMode: true,
  freeModeMomentum: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1400: {
      enabled: false,
    },
    0: {
      enabled: true,
      slidesPerView: 1.5,
    }
  }
});

// init Swiper for the always-enabled slider
var swiperAlwaysOn = new Swiper(".mySwiperAll", {
  slidesPerView: 4,
  centeredSlides: false,
  spaceBetween: 20,
  grabCursor: true,
  freeMode: true,
  freeModeMomentum: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    // Viewport >= 1400px
    1400: {
      slidesPerView: 4,
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    // Viewport >= 1024px
    1024: {
      slidesPerView: 3,
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    // Viewport >= 768px
    768: {
      slidesPerView: 2,
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    // Viewport < 768px
    0: {
      slidesPerView: 1.25,
      pagination: {
        enabled: false,  // Keep pagination disabled on tablet
      },
    }
  }
});

// init Swiper for narrow layout (sidebar/constrained areas)
var swiperNarrow = new Swiper(".mySwiperNarrow", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  centeredSlides: false,
  spaceBetween: 20,
  grabCursor: true,
  freeMode: true,
  freeModeMomentum: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // Viewport >= 1400px (xl) - sidebar layout, 75% width
    1400: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    // Viewport >= 1200px (xl) - sidebar layout, 75% width
    1200: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    // Viewport >= 992px (lg) - sidebar layout, 75% width
    992: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    // Viewport >= 768px (md) - sidebar stacks, 100% width but narrower
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      pagination: {
        enabled: true,  // Keep pagination enabled on tablet
      },
    },
    // Viewport < 768px (sm/xs) - mobile, single slide
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      pagination: {
        enabled: false,  // Keep pagination disabled on tablet
      },
    }
  }
});

